import ApiClient from '@/api/apiClient';

class InstanceService {
    async getOne(id: string) {
        const url: string = `/instances/${id}`;
        const defaultValue = null;
        const errorPath: string = '[api:instance:getOne]';
        return await ApiClient.user.get(url, defaultValue, errorPath);
    }

    async getOwned() {
        const url: string = `/instances`;
        const defaultValue = null;
        const errorPath: string = '[api:instance:getOwned]';
        return await ApiClient.user.get(url, defaultValue, errorPath);
    }

    async getAll() {
        const url: string = `/instances/all`;
        const defaultValue = null;
        const errorPath: string = '[api:instance:getAll]';
        return await ApiClient.user.get(url, defaultValue, errorPath);
    }

    async createOne(id: string) {
        const url: string = `/instances`;
        const defaultValue = null;
        const errorPath: string = '[api:instance:getAll]';
        const data = { instanceId: id };
        return await ApiClient.user.post(url, defaultValue, errorPath, data);
    }
}

export default new InstanceService();

/*
import httpClient from '@/api/httpClient';
import EventEmitter from '@/helpers/eventEmitter';
import i18n from '@/i18n';

class InstanceService {
    async getAll() {
        const response = await httpClient({
            url: '/instances',
            method: 'get',
        });
        console.log(response);
        return new Promise((resolve) => resolve(response.data));
    }

    async addOne(payload) {
        try {
            const response = await httpClient({
                url: '/instances',
                method: 'post',
                data: payload,
            });
            console.log(response);

            if (response.status > 400) throw {
                statusCode: response.status,
                message: 'Inner Failed'
            };

            EventEmitter.trigger('show-noty', { type: 'success', text: i18n.global.t('notifications.success.instanceAdd') });
            return new Promise((resolve) => resolve(response.data));
        } catch (error) {
            EventEmitter.trigger('show-noty', {
                type: 'error',
                text: `Error occurred. Status ${error.statusCode}: ${error.message}`,
            });
        }
    }
}

export default new InstanceService();
*/
